import { ClientApp, ClientAppProps, initPerformanceAnalytics } from '@stitch-fix/sf-next';
import { GraphQLApiProvider } from '../components/GraphQLApiProvider';
import { initializeDatadogLogs } from '../utils/initializeDatadogLogs';

// Initialize performance analytics for your project.
// For configuration options, including how to debug locally or increase
// the sample rate, view guide at:
// https://github.com/stitchfix/sf-next/blob/beta/docs/analytics.md
initPerformanceAnalytics({
  sampleRate: 60
});
initializeDatadogLogs();
if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
  // require is synchronous, which allows MSW to be initialized before the app renders,
  // see: https://github.com/mswjs/msw/discussions/1236
  // eslint-disable-next-line global-require
  require('../mocks/msw');
}
const App = (props: ClientAppProps) => {
  return <ClientApp {...props} GraphQLApiProvider={GraphQLApiProvider} />;
};

// Report on next.js metrics and mark `app_rendered`.
// AUTOGENERATED BY SF-NEXT TO SUPPORT TRACKING PERFORMANCE ANALYTICS.
// DO NOT REMOVE.
export { reportWebVitals } from '@stitch-fix/sf-next';
export default App;